import React, { useEffect } from "react";
import HeaderNav from "./common/HeaderNav";
import Footer from "./Footer";
import tc from "../images/tc.png";

function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title =
      "Terms & Conditions | Trusted Provider of Premium Mobile Numbers Since 2010";
    document
      .querySelector("meta[name='description']")
      .setAttribute(
        "content",
        "Learn about VIP Number Studio, a trusted provider of premium mobile numbers across India since 2010. Discover our commitment to delivering over 10,000 exclusive numbers and our dedication to customer satisfaction."
      );
  }, []);
  return (
    <>
      <HeaderNav />
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "300px",
          overflow: "hidden",
          marginTop: "60px",
        }}
      >
        {/* Background Image */}
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundImage: `url(${tc})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        {/* Gradient Overlay */}
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            background: "#000040",
          }}
        ></div>
        {/* Red circular accent */}
        <div
          style={{
            position: "absolute",
            width: "300px",
            height: "300px",
            backgroundColor: "rgba(255, 0, 0, 0.8)",
            borderRadius: "50%",
            top: "-150px",
            right: "-100px",
            zIndex: 1,
          }}
        ></div>

        {/* Second red circular accent */}
        <div
          style={{
            position: "absolute",
            width: "150px",
            height: "150px",
            backgroundColor: "rgba(255, 0, 0, 0.8)",
            borderRadius: "50%",
            bottom: "-70px",
            left: "50px",
            zIndex: 1,
          }}
        ></div>

        {/* Decorative dots */}
        <div
          style={{
            position: "absolute",
            top: "20px",
            left: "20px",
            display: "flex",
            gap: "5px",
          }}
        >
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
            }}
          ></div>
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
            }}
          ></div>
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
            }}
          ></div>
        </div>

        {/* Decorative triangle */}
        <div
          style={{
            position: "absolute",
            bottom: "15px",
            right: "60px",
            width: 0,
            height: 0,
            borderLeft: "15px solid transparent",
            borderRight: "15px solid transparent",
            borderBottom: "26px solid rgba(255, 255, 255, 0.15)",
            transform: "rotate(45deg)",
          }}
        ></div>

        {/* Content Container */}
        <div
          style={{
            position: "relative",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "0 20px",
            zIndex: "2",
          }}
        >
          <h1
            style={{
              color: "white",
              fontSize: "42px",
              fontWeight: "800",
              marginBottom: "16px",
              textAlign: "center",
              textShadow: "2px 2px 8px rgba(0, 0, 0, 0.6)",
            }}
          >
            Terms & Conditions
          </h1>

          <p
            style={{
              color: "white",
              fontSize: "18px",
              fontWeight: "400",
              maxWidth: "700px",
              textAlign: "center",
              textShadow: "1px 1px 4px rgba(0, 0, 0, 0.8)",
            }}
          >
            Important guidelines governing the use of our platform
          </p>

          {/* Decorative Line */}
          <div
            style={{
              width: "80px",
              height: "4px",
              background:
                "linear-gradient(90deg,rgba(255, 255, 255, 0.74), rgb(233, 2, 2))",
              marginTop: "20px",
              borderRadius: "2px",
            }}
          ></div>
        </div>
      </div>
      <div className="terms">
        <div className="container">
          <div className="row">
            <div className="titlex">
              <h1 className="policy-header">Terms & Conditions</h1>
            </div>
            <div className="contentx">
              <p className="headingx text-muted">
                Last updated on {new Date().getFullYear()}
              </p>
              <p className="para1">
                The Website Owner, including subsidiaries and affiliates
                (“Website” or “Website Owner” or “we” or “us” or “our”) provides
                the information contained on the website or any of the pages
                comprising the website (“website”) to visitors (“visitors”)
                (cumulatively referred to as “you” or “your” hereinafter)
                subject to the terms and conditions set out in these website
                terms and conditions, the privacy policy and any other relevant
                terms and conditions, policies and notices which may be
                applicable to a specific section or module of the website.
              </p>
              <p className="para2">
                Welcome to our website. If you continue to browse and use this
                website you are agreeing to comply with and be bound by the
                following terms and conditions of use, which together with our
                privacy policy govern MODERN TELECOM SALES AND SERVICES''s
                relationship with you in relation to this website.
              </p>
              <p className="para3">
                The term 'MODERN TELECOM SALES AND SERVICES' or 'us' or 'we'
                refers to the owner of the website whose registered/operational
                office is SHOP NO.2 MAHAPE ROAD OPP REGAL RESTAURANT SHILPHATA
                Thane MAHARASHTRA 421204. The term 'you' refers to the user or
                viewer of our website.
              </p>
              <p className="heading1">
                <h6>
                  The use of this website is subject to the following terms of
                  use:
                </h6>
              </p>
              <p className="listsx">
                <ul>
                  <li className="list-content">
                    The content of the pages of this website is for your general
                    information and use only. It is subject to change without
                    notice.
                  </li>
                  <li className="list-content">
                    Neither we nor any third parties provide any warranty or
                    guarantee as to the accuracy, timeliness, performance,
                    completeness or suitability of the information and materials
                    found or offered on this website for any particular purpose.
                    You acknowledge that such information and materials may
                    contain inaccuracies or errors and we expressly exclude
                    liability for any such inaccuracies or errors to the fullest
                    extent permitted by law.
                  </li>
                  <li className="list-content">
                    Your use of any information or materials on this website is
                    entirely at your own risk, for which we shall not be liable.
                    It shall be your own responsibility to ensure that any
                    products, services or information available through this
                    website meet your specific requirements.
                  </li>
                  <li className="list-content">
                    This website contains material which is owned by or licensed
                    to us. This material includes, but is not limited to, the
                    design, layout, look, appearance and graphics. Reproduction
                    is prohibited other than in accordance with the copyright
                    notice, which forms part of these terms and conditions.
                  </li>
                  <li className="list-content">
                    All trademarks reproduced in this website which are not the
                    property of, or licensed to, the operator are acknowledged
                    on the website.
                  </li>
                  <li className="list-content">
                    Unauthorized use of this website may give rise to a claim
                    for damages and/or be a criminal offense.
                  </li>
                  <li className="list-content">
                    From time to time this website may also include links to
                    other websites. These links are provided for your
                    convenience to provide further information.
                  </li>
                  <li className="list-content">
                    You may not create a link to this website from another
                    website or document without MODERN TELECOM SALES AND
                    SERVICES’s prior written consent.
                  </li>
                  <li className="list-content">
                    Your use of this website and any dispute arising out of such
                    use of the website is subject to the laws of India or other
                    regulatory authority.
                  </li>
                </ul>
              </p>
              <p className="para4">
                We as a merchant shall be under no liability whatsoever in
                respect of any loss or damage arising directly or indirectly out
                of the decline of authorization for any Transaction, on Account
                of the Cardholder having exceeded the preset limit mutually
                agreed by us with our acquiring bank from time to time
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default TermsAndConditions;
